import { api } from '$lib/api.js';
import { auth } from '$lib/stores/auth.js';

const DASHBOARD_ROUTE = '/dashboard';
const LANDING_ROUTE = '/';
const DEMO_GUIDE_DISMISSED_KEY = 'autopaylot_demo_guide_dismissed';

/** Start a fully provisioned disposable demo without signup or bank access. */
export async function startDemoMode(): Promise<void> {
	const { accessToken } = await api.demo.start();
	auth.setTokens(accessToken);
	clearDemoGuideDismissal();
	await waitForDemoAccounts();
	hardReloadTo(DASHBOARD_ROUTE);
}

/** Replace the current fictional workspace with a clean seeded workspace. */
export async function resetDemoMode(): Promise<void> {
	const { accessToken } = await api.demo.reset();
	auth.setTokens(accessToken);
	clearDemoGuideDismissal();
	hardReloadTo(DASHBOARD_ROUTE);
}

/** Delete the disposable workspace and return to the public landing page. */
export async function leaveDemoMode(): Promise<void> {
	try {
		await api.demo.end();
	} catch {
		// The workspace may already have expired; still clear local auth state.
		await api.auth.logout().catch(() => {});
	}
	auth.logout();
	hardReloadTo(LANDING_ROUTE);
}

function clearDemoGuideDismissal(): void {
	if (typeof window === 'undefined') return;
	window.sessionStorage.removeItem(DEMO_GUIDE_DISMISSED_KEY);
}


async function waitForDemoAccounts(): Promise<void> {
	const deadline = Date.now() + 20_000;
	while (Date.now() < deadline) {
		try {
			if ((await api.accounts.list()).accounts.length >= 4) return;
		} catch {
			// The short-lived demo session may not be visible to the first poll.
		}
		await new Promise((resolve) => setTimeout(resolve, 1_000));
	}
}

function hardReloadTo(path: string): void {
	if (typeof window === 'undefined') return;
	// Full navigation ensures all in-memory stores re-bootstrap from the new
	// disposable session cookie.
	window.location.assign(path);
}
